(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["firmware-updates"] && !Shopify.designMode) return;
  try {
    class FirmwareUpdates extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('.firmware-updates__status');
      this.actions = this.querySelector('.firmware-updates__actions');
      this.fetchUpdateInfo();
    }

    fetchUpdateInfo() {
      const productId = this.dataset.productId;
      const url = `${this.dataset.apiUrl}?product_id=${encodeURIComponent(productId)}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then((data) => this.render(data))
        .catch(() => this.renderError());
    }

    bestEntry(results) {
      return results.stable || results.latest || results.previous || null;
    }

    isSafeUrl(value) {
      if (!value) return false;
      try {
        const parsed = new URL(value, window.location.href);
        return parsed.protocol === 'https:' || parsed.protocol === 'http:';
      } catch (error) {
        return false;
      }
    }

    buildButton(href, label, attrs) {
      const link = document.createElement('a');
      link.className = 'button button--secondary firmware-updates__button';
      link.href = href;
      link.textContent = label;
      Object.keys(attrs).forEach((key) => link.setAttribute(key, attrs[key]));
      return link;
    }

    render(data) {
      const results = data && data.results;

      if (!results || data.error) {
        this.renderError();
        return;
      }

      const entry = this.bestEntry(results);
      if (!entry) {
        this.renderError();
        return;
      }

      const fragment = document.createDocumentFragment();
      let added = false;

      if (this.isSafeUrl(entry.file_url)) {
        let label = this.dataset.labelDownload;
        if (entry.version) {
          label = `${label} (${this.dataset.labelVersion}${entry.version})`;
        }
        fragment.appendChild(this.buildButton(entry.file_url, label, { download: '' }));
        added = true;
      }

      if (this.isSafeUrl(entry.release_notes_url)) {
        fragment.appendChild(
          this.buildButton(entry.release_notes_url, this.dataset.labelReleaseNotes, {
            target: '_blank',
            rel: 'noopener',
          })
        );
        added = true;
      }

      if (!added) {
        this.renderError();
        return;
      }

      this.status.hidden = true;
      this.actions.hidden = false;
      this.actions.replaceChildren(fragment);
    }

    renderError() {
      this.status.textContent = this.dataset.labelError;
      this.actions.hidden = true;
    }
  }

  customElements.define('firmware-updates', FirmwareUpdates);
  } catch(e) { console.error(e); }
})();

})();
